import React from 'react';
import Styles from './table-not-found-styles.scss';
import { NotFoundIcon } from '../../icons';
import { ButtonReset } from '@/presentation/components';
const TableNotFound = ({ term, onClick }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.tableNotFoundWrap },
            React.createElement("div", { className: Styles.icon },
                React.createElement(NotFoundIcon, null)),
            React.createElement("div", { className: Styles.title }, term ? `No results found by "${term}"` : 'No results found'),
            React.createElement("div", { className: Styles.subtitle }, "Please try another request"),
            React.createElement("div", { className: Styles.btnReset },
                React.createElement(ButtonReset, { onClick: onClick })))));
};
export default TableNotFound;
